import { Component, Input } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'
import { DocumentsPrefForm } from '@tv3/containers/documents/preferences/form/documents-pref-form'
import { AutomationWizardSaveAction, AutomationWizardCloseAction } from '../../automations-wizard.actions'

@Component({
  selector: 'app-document-notifications-pref-list',
  templateUrl: './document-notifications-pref-list.component.html',
})
export class DocumentNotificationsPrefListComponent extends DocumentsPrefForm {
  @Input() notifyType: 'signer' | 'user' = 'signer'

  constructor(protected fb: FormBuilder, protected store: Store<any>, private actions: Actions) {
    super(fb, store)
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.actions.pipe(ofType(AutomationWizardSaveAction), untilDestroy(this)).subscribe((action) => {
      this.save()
      if (action.closeAfterSave) {
        this.store.dispatch(AutomationWizardCloseAction())
      }
    })
  }
}
